import type { TenantModules } from '../schemas/tenantModules'

/** Fail closed for declared requirements, compatible with ungated existing features. */
export function canReadModule(modules: TenantModules | undefined, key?: string) {
  return !key || modules?.[key]?.canRead === true
}
export function canWriteModule(modules: TenantModules | undefined, key?: string) {
  return !key || modules?.[key]?.canWrite === true
}
